<section class="dalel-page" dir="rtl">
  <div class="page-hero">
    <div class="shell">
      <p class="page-kicker">دليل بلس</p>
      <h1>سياسة الاستبدال والاسترجاع</h1>
    </div>
  </div>
  <div class="page-body shell">
    <ol>
      <li>
        <h2>1. إلغاء الاشتراك واسترداد المبلغ</h2>
        <p>• يمكن للمشتركين طلب استرداد المبلغ خلال يومين من تاريخ الاشتراك، وفقًا لسياسة الموقع.</p>
        <p>• بعد انقضاء هذه الفترة، لن يكون هناك استرداد للمبالغ المدفوعة.</p>
      </li>
      <li>
        <h2>2. الاستبدال أو الترقية</h2>
        <p>• يمكن للمشترك الترقية إلى باقة أعلى مع دفع الفارق.</p>
        <p>• في حال رغبة المشترك في تغيير الباقة إلى فئة أقل، لن يتم استرداد الفرق المالي.</p>
      </li>
      <li>
        <h2>3. إيقاف الاشتراك وتجديده</h2>
        <p>• يمكن إيقاف الاشتراك بناءً على طلب المشترك، ولكن لن يتم استرداد أي مبالغ بعد انتهاء فترة الاسترداد المحددة.</p>
        <p>• يتم تجديد الاشتراك تلقائيًا ما لم يقم المشترك بإلغائه قبل موعد التجديد.</p>
      </li>
      <li>
        <h2>4. شروط خاصة بالخدمات الرقمية</h2>
        <p>• في حال تم استخدام الخدمة أو الوصول إلى المحتوى المدفوع، قد لا يكون الاسترجاع متاحًا.</p>
        <p>• أي استرداد يكون وفقًا لتقدير إدارة الموقع وحسب الحالة.</p>
      </li>
      <li>
        <h2>5. آلية طلب الاستبدال أو الاسترجاع</h2>
        <p>• يتم تقديم الطلب عبر البريد الإلكتروني أو نموذج الدعم الفني على الموقع.</p>
        <p>• يتم معالجة الطلب خلال عدد معين من الأيام وفقًا لسياسة الموقع.</p>
      </li>
    </ol>
  </div>
</section>
